export const SRS = {
	i: [
		{
			c: [
				{ x: -2, y: 0 },
				{ x: 1, y: 0 },
				{ x: -2, y: 1 },
				{ x: 1, y: -2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: 2, y: 0 },
				{ x: -1, y: -2 },
				{ x: 2, y: 1 },
			],
		}, {
			c: [
				{ x: -1, y: 0 },
				{ x: 1, y: 0 },
				{ x: -1, y: -2 },
				{ x: 2, y: 1 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: -1, y: 0 },
				{ x: 2, y: -1 },
				{ x: -1, y: 2 },
			],
		}, {
			c: [
				{ x: 2, y: 0 },
				{ x: -1, y: 0 },
				{ x: 2, y: -1 },
				{ x: -1, y: 2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: -2, y: 0 },
				{ x: 1, y: 2 },
				{ x: -2, y: -1 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: -2, y: 0 },
				{ x: 1, y: 2 },
				{ x: -2, y: -1 },
			],
			cc: [
				{ x: -2, y: 0 },
				{ x: 1, y: 0 },
				{ x: -2, y: 1 },
				{ x: 1, y: -2 },
			],
		},
	],
	o: [
		{
			c: [],
			cc: [],
		}, {
			c: [],
			cc: [],
		}, {
			c: [],
			cc: [],
		}, {
			c: [],
			cc: [],
		},
	],
	t: [
		{
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
		}, {
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
		},
	],
	j: [
		{
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
		}, {
			c: [
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 1 },
				{ x: -1, y: 2 },
			],
		}, {
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
		},
	],
	l: [
		{
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
		}, {
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
		},
	],
	s: [
		{
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
		}, {
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
		},
	],
	z: [
		{
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: -1 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: 1 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
			cc: [
				{ x: 1, y: 0 },
				{ x: 1, y: 2 },
				{ x: 0, y: -2 },
				{ x: 1, y: -2 },
			],
		}, {
			c: [
				{ x: 1, y: 0 },
				{ x: 1, y: -1 },
				{ x: 0, y: 2 },
				{ x: 1, y: 2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: -2 },
				{ x: 0, y: 2 },
				{ x: -1, y: 2 },
			],
		}, {
			c: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
			cc: [
				{ x: -1, y: 0 },
				{ x: -1, y: 1 },
				{ x: 0, y: -2 },
				{ x: -1, y: -2 },
			],
		},
	],
}
